import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Users, Video, Bot, Leaf, TreeDeciduous, ShoppingBag } from 'lucide-react';

const TAB_ITEMS = [
  { path: '/feed', label: 'Feed', icon: Home },
  { path: '/grupos', label: 'Grupos', icon: Users },
  { path: '/reunioes', label: 'Reuniões', icon: Video },
  { path: '/aria', label: 'ARIA', icon: Bot },
  { path: '/jardim', label: 'Jardim', icon: Leaf },
  { path: '/minha-arvore', label: 'Árvore', icon: TreeDeciduous },
  { path: '/loja', label: 'Loja', icon: ShoppingBag },
];

export function BottomTabBar() {
  const navigate = useNavigate();
  const location = useLocation();

  const hiddenPaths = ['/login', '/quiz', '/admin', '/curso/', '/reunioes/'];
  const isInMeetingRoom = location.pathname.match(/\/reunioes\/.+\/room/);
  const shouldHide = hiddenPaths.some(p => location.pathname.startsWith(p)) || isInMeetingRoom || location.pathname === '/';
  if (shouldHide) return null;

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 border-t border-border/40 bg-background/80 backdrop-blur-xl"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      data-testid="bottom-tab-bar"
    >
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto px-1">
        {TAB_ITEMS.map(tab => {
          const Icon = tab.icon;
          const isActive = tab.path === '/feed'
            ? location.pathname === '/feed'
            : location.pathname.startsWith(tab.path);

          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className="flex flex-col items-center justify-center flex-1 h-full gap-0.5 relative group"
              data-testid={`tab-${tab.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')}`}
            >
              {isActive && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full bg-primary" />
              )}
              <Icon
                className={`h-5 w-5 transition-colors duration-200 ${
                  isActive ? 'text-primary' : 'text-muted-foreground group-hover:text-foreground'
                }`}
                strokeWidth={isActive ? 2 : 1.5}
              />
              <span className={`text-[10px] leading-none transition-colors duration-200 ${
                isActive ? 'text-primary font-semibold' : 'text-muted-foreground'
              }`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
